import { useTranslate } from 'react-redux-multilingual'

export const useDocumentTypes = () => {
    const t = useTranslate();

    return {
        po: t('purchaseOrder'),
        shipment: t('shipmentVoucher'),
        entre: t('entreStockRecords'),
        simple: t('stockDeplacement'),
        cancelEntre: t('cancellationStockEntry'),
        ajust: t('stockAdjustment'),
        to: t('transferOrder'),
        ticket: t('ticket'),
        commande: t('salesOrder'),
        reassortInterne: t('internalRestock'),
        inventaire: t('inventory'),
        resolveNegative: t('resolveNegative'),
        facture: t('billing'),
        billing: t('billing'),
        toRecords: t('transferOrder'),
        quotation: t('quotation'),
        purchaseOrderB2b: t('purchaseOrderB2b'),
        poB2b: t('poB2bMouvement'),
        deliveryNote: t('deliveryNote'),
        deliveryNoteOutStock: t('deliveryNoteOutStock'),
        creditNote: t('creditNote'),
        returnNote: t('returnNote'),
        rn: t('returnNoteReturnInStock'),
        billingBuy: t('billingBuy'),
        creditNoteBuy: t('creditNoteBuy'),
        billingOutStock: t('billingOutStock'),
        carrepos: t('carrepos')
    };
};